module.exports = new __parcel__URL__("purecrystal.44fbdb7b.png").toString();